import React from 'react';

import Box from '../Box'

export default props => {
    return (
        <section className="container">
            <Box {...props} id="b1" type="ABridTile" settings={props.settings.b1} preserveImageRatio={true} classes="" />
        </section>
    );
}